module.exports = __webpack_public_path__ + "static/img/3_2.61ced734.jpg";